import type {ComponentProps} from 'react';
import {tr, txt, type Texto} from '../i18n/idioma';
import {NotaDeAyuda} from './nota-de-ayuda';
import {PistaDeSoltar, ZonaParaSoltar} from './zona-para-soltar';

const AYUDA_DE_ARCHIVO = txt(
  'Elige el archivo en tu computador. La app lo lee y muestra lo que cambiaría; nada se guarda hasta que confirmes.',
  'Choose the file on your computer. The app reads it and shows what would change; nothing is saved until you confirm.',
);

// Titulo arriba y el boton debajo, para formularios con varios archivos. La i
// dice que archivo va y de donde sale (yuda); sin ella, una nota general.
export function CampoDeArchivo({ayuda, ...props}: ComponentProps<typeof ElegirArchivo> & {ayuda?: Texto | string}) {
  return (
    <div className="flex flex-col gap-1 text-xs text-apagado">
      <span>
        {props.etiqueta}
        <NotaDeAyuda titulo={props.etiqueta} texto={ayuda ?? AYUDA_DE_ARCHIVO} />
      </span>
      <ElegirArchivo {...props} />
    </div>
  );
}

// Boton para elegir archivos. El campo de archivo del navegador sale como
// texto plano ("Choose File No file chosen") con los estilos de la app y no
// parece un boton; este se ve como los demas y dice que archivo se eligio.
export function ElegirArchivo({
  etiqueta,
  accept,
  multiple = false,
  archivos,
  onElegir,
  deshabilitado = false,
  textoBoton,
}: {
  // Nombre accesible del campo (lo usan los lectores de pantalla y las pruebas).
  etiqueta: string;
  accept: string;
  multiple?: boolean;
  archivos: File[];
  onElegir: (archivos: File[]) => void;
  deshabilitado?: boolean;
  textoBoton?: string;
}) {
  return (
    <ZonaParaSoltar
      accept={accept}
      multiple={multiple}
      deshabilitado={deshabilitado}
      onSoltar={onElegir}
      className="inline-flex flex-wrap items-center gap-2"
    >
      <label
        className={`inline-flex cursor-pointer items-center gap-1 rounded-md border border-verde bg-white px-3 py-1.5 text-sm text-verde-oscuro hover:bg-verde-claro ${deshabilitado ? 'pointer-events-none opacity-50' : ''}`}
      >
        📂 {textoBoton ?? (multiple ? tr('Elegir archivos', 'Choose files') : tr('Elegir archivo', 'Choose file'))}
        <input
          type="file"
          accept={accept}
          multiple={multiple}
          disabled={deshabilitado}
          aria-label={etiqueta}
          className="sr-only"
          onChange={e => {
            onElegir([...(e.target.files ?? [])]);
            // Permite volver a elegir el mismo archivo despues de cambiarlo en Excel.
            e.target.value = '';
          }}
        />
      </label>
      <span className="text-sm text-apagado">
        {archivos.length
          ? archivos.map(a => a.name).join(', ')
          : multiple
            ? tr('Ningún archivo elegido', 'No files chosen')
            : tr('Ningún archivo elegido', 'No file chosen')}
      </span>
      {!archivos.length && !deshabilitado && <PistaDeSoltar multiple={multiple} />}
    </ZonaParaSoltar>
  );
}
